
import TableList from "@components/templates/tablelist";
import { HttpVoteNoInboundList,HttpVoteNoInboundExport} from "@/service/report";
// import mixin from "../mixin";
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpVoteNoInboundList,
        interceptRequest(params){
            const orderNo = params.search['orderNo'];
            const orderType = params.search['orderType'];
            const tmsNo = params.search['tmsNo'];
            const lineId = params.search['lineId'];
            const orgWarehouseId = params.search['orgWarehouseId'];
            const errorStatus = params.search['errorStatus'];
            const estimate = params.search['estimate']||'';
            params.orderNo = orderNo;
            params.orderType = orderType;
            params.tmsNo = tmsNo;
            params.lineId = lineId;
            params.orgWarehouseId = orgWarehouseId;
            params.errorStatus = errorStatus;
            const estArray = estimate.split('~');
            params.estimateStart = estArray[0];
            params.estimateEnd = estArray[1];
            delete params.search['orderNo'];
            delete params.search['orderType'];
            delete params.search['tmsNo'];
            delete params.search['lineId'];
            delete params.search['orgWarehouseId'];
            delete params.search['errorStatus'];
            delete params.search['errorStatus'];
            delete params.search['estimate'];
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                // case "query":
                //     var url = this.$router.resolve({
                //         name: "allotUpdateManage",
                //         params: { type: "query" },
                //         query: { id: params },
                //     });
                //     window.open(url.href, '_blank');
                //     break;
                case 'export':
                    this.handleWebfs(HttpVoteNoInboundExport, this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return []
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getWarehouseList','getProductList']),
    // TabsData() {
    //     return [
    //         {
    //             name: "所有",
    //             key: 'EQ_transferOutboundPlanStatus',
    //             value: null
    //         }, {
    //             name: "待审核",
    //             key: 'EQ_transferOutboundPlanStatus',
    //             value: 5
    //         }, {
    //             name: "已取消",
    //             key: 'EQ_transferOutboundPlanStatus',
    //             value: 110
    //         }
    //     ]
    // },
    ToolsData() {
        return [
            // {
            //     name: "批量审核",
            //     operate: "approve",
            //     theme: "primary",
            //     batch: true,
            // },
            {
                name: "批量导出",
                operate: "export",
                theme: "info",
                // batch: true,
            },
        ]
    },
    SearchsData() {
        return [
            {
                label: "入库类型",
                tag: 'vSelect',
                key: 'orderType',
                show: true,
                options:[
                    {
                        label:"中转入库计划",
                        value:100
                    },
                    {
                        label:"入库计划",
                        value:420
                    }
                ]
            },
            {
                label: "单号",
                tag: 'vInput',
                key: 'orderNo',
                show:true
            },
            {
                label: "物流单号",
                tag: 'vInput',
                key: 'tmsNo'
            },

            {
                label: "项目",
                tag: 'vSelect',
                key: 'lineId',
                options:this.getProductList.map(function(item){
                    return {
                        label:item.attach.name,
                        value:item.id
                    }
                }),
                props:{
                    filterable:true
                },
                show:true
            },

            {
                label: "仓库",
                tag: 'vSelect',
                key: 'orgWarehouseId',
                options :this.getWarehouseList,
                props:{
                    filterable:true
                }
            },
            {
                label: "异常状态",
                tag: 'vSelect',
                key: "errorStatus",
                options:[
                    {
                        label:"未超时",
                        value:0
                    },{
                        label:"超时接收",
                        value:1
                    }
                ]
            },
            {
                label: "预计到仓时间",
                key: 'estimate',
                more: true,
                tag: 'vDatepicker',
                props: {
                    format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    confirm: false,
                },
            }
        ]
    },
    columns() {
        // return [{
        //     type: 'selection',
        //     width: 40,
        //     align: 'center',
        //     formName: 'id'
        // },
        // {
        //     title: '操作',
        //     maxWidth: 90,
        //     render: this.getOperateNodes
        // },
        return[
            // {
            //     type: 'selection',
            //     width: 40,
            //     align: 'center',
            //     formName: 'id'
            // },
            {
            title: '业务类型',
            key: 'orderType',
            render: (h, { row }) => this.findRenderLabel([
            {
                label:"中转入库计划",
                value:100
            },
            {
                label:"入库计划",
                value:420
            }
        ], row.orderType)
        },
            {
                title: '订单号',
                key: 'orderNo'
        },
        {
                title: '项目',
                key: 'lineName'
        },
        {
                title: '仓库',
                key: 'orgWarehouseCode'
        },
        {
                title: '物流单号',
                key: 'tmsNo'
        },
        {
                title: '预计到仓日期',
                key: 'estimateArriveTime'

        },
        {
                title: '到仓时间',
                key: 'actualArriveTime'
            // template: "orgWarehouseCode"
        },
        {
                title: '接收状态',
                key: 'receiveStatusInfo'
        },
        {
                title: '计划数量',
                key: 'planQty'
        },
        {
                title: '实际接收数量',
                key: 'receivedQty'
        },
        {
                title: '异常状态',
                key: 'errorStatus',
            render: (h, { row }) => this.findRenderLabel([
            {
                label:"未超时",
                value:0
            },
            {
                label:"超时接收",
                value:1
            }
        ], row.errorStatus)
        }
    ];
    },

},

};
